import {http} from "Services/Http/HttpClient";

export interface PaymentMethod {
    id: string,
    cardLast4: string,
    cardExpiry: string,
    cardBrand: string,
    isDefault: boolean,
    status: string,
    createdAt: string,
}

export const getPaymentMethods = async (): Promise<any> => {
    return await http.get(`users/payment-methods`)
}
